import { IotButtonBase } from "@core/presentation/components/general/button/iot-button-base.component";
import { IotButtonForm } from "@core/presentation/components/general/button/iot-button-form.component";

// The form button renders the base, so the compound lives here to keep both files out of an import cycle
export const IotButton = Object.assign(IotButtonBase, { Form: IotButtonForm });
